<div class="container mt-5">
  <header class="hero">
    <div class="hero-content row">
      <div class="col-md-6 col-12">
        <h1>{{"cms.header.title" | translate}}</h1>
        <p class="subtitle">{{"cms.header.description" | translate}}</p>
        <div class="hero-btns">
          <!-- <a class="btn btn-primary mr-3" [routerLink]="['/get-started' | localize]">{{'cms.get_started' |
            translate}}</a> -->
            <a class="btn btn-outline-primary" href="https://calendly.com/medoc-/cms-demo"
            target="_blank">{{'cms.book_live_demo' | translate}}</a>
        </div>
      </div>
      <div class="hero-images col-md-6 col-12" [ngClass]="isEnglish ? 'right' : 'left'">
        <picture>
          <source srcset="assets/images/solution/hero.webp 400w,
                          assets/images/solution/hero.webp 800w,
                          assets/images/solution/hero.webp 1200w"
            sizes="(max-width: 600px) 400px, (max-width: 1200px) 800px, 1200px" type="image/webp">
          <img src="assets/images/solution/hero.webp" alt="solution hero" width="400" height="100%">
        </picture>
      </div>
    </div>
  </header>
</div>

<div class="container">
  <div class="row my-5 py-4">
    <div class="col-md-4 col-12  mt-3 ">
      <div class="d-flex flex-column align-items-start">
        <h2>{{'cms.customers.title' | translate}}</h2>
        <p>{{'cms.customers.description' | translate}}</p>
        <button class="btn btn-link text-start p-0 mt-3 ">
          {{'cms.customers.join_our_network' | translate}}
          <i class="fas fa-arrow-right ml-2"></i>
        </button>
      </div>
    </div>
    <div class="col-md-8 col-12 mt-md-3 mt-5">
      <div class="row align-items-center ">
        <div *ngFor="let customer of customers" class="col-3 customer">
          <img [src]="customer.path" loading="lazy" [alt]="customer.name" height="100%" width="120">
        </div>
      </div>
    </div>
  </div>
</div>

<div class="py-5 text-center solution bg-light">
  <div class="container">
    <h2 class="mb-3"> {{'cms.solutions.title' | translate}}</h2>
    <p class="">{{'cms.solutions.description' | translate}}</p>
    <div class="row my-5">
      <div *ngFor="let solution of solutions" class="col-md-4 solution-card">
        <app-icon [icon]="solution.icon" size="64px" class="preserve-color-on-hover"></app-icon>
        <h4 class="my-2">{{ solution.title | translate }}</h4>
        <p>{{ solution.description | translate }}</p>
        <!-- <a class="btn btn-link my-2" [routerLink]="['/get-started' | localize]">
            {{ 'cms.get_started' | translate }}
            <i class="fas fa-arrow-right ml-2"></i>
          </a> -->
      </div>
    </div>
  </div>
</div>




<div class="container text-center my-5">
  <h2> {{'cms.why_medoc.title' | translate}}</h2>
  <div class="row align-items-center h-100 text-center pt-4 my-5">
    <div class="col-12 col-md-4 py-5 moving-animate" *ngFor="let item of whymedoc">
      <div class="mx-2">
        <app-icon [icon]="item.icon" [size]='item.size'></app-icon>
        <h4 class="text-small py-2 ">{{ item.title | translate }}</h4>
        <p>{{ item.description | translate }}</p>
      </div>
    </div>
  </div>
  <!-- <div class="text-center d-flex justify-content-center">
    <a class="btn btn-link align-items-center d-flex my-2" [routerLink]="['/get-started' | localize]">
      {{'cms.get_started' | translate}}
      <i class="fas fa-arrow-right ml-2"></i>
    </a>
  </div> -->
</div>

<div class="bg-light py-5 timeline">
  <div class="container">
    <h3 class="text-center">{{'cms.get_started' | translate}}</h3>
    <div class="row my-5">
      <div *ngFor="let step of steps" class="col-md-4 py-3 col-12 timeline-step">
        <div class="dot"></div>
        <h5 class="my-2">{{ step.title | translate }}</h5>
        <p>{{ step.description | translate }}</p>
      </div>
    </div>
    <!-- <div class="text-center d-flex justify-content-center">
      <a class="btn btn-link align-items-center d-flex my-2" [routerLink]="['/get-started' | localize]">
        {{'cms.get_started' | translate}}
        <i class="fas fa-arrow-right ml-2"></i>
      </a>
    </div> -->
  </div>
</div>

<div class="container">
  <div class="my-5">
    <h2 class="text-center">{{ 'cms.features.title' | translate }}</h2>
    <div class="row text-center mt-5">
      <div *ngFor="let feature of features" class="col-md-4 col-6">
        <div class="feature-box p-0 p-md-3 my-3">
          <app-icon [icon]="feature.icon" size="48px"></app-icon>
          <h4 class="my-2">{{ feature.title | translate }}</h4>
          <p>{{ feature.description | translate }}</p>
        </div>
      </div>
    </div>
    <!-- <div class="text-center mb-3 d-flex justify-content-center">
      <a class="btn btn-link align-items-center d-flex my-2" [routerLink]="['/get-started' | localize]">
        {{'cms.get_started' | translate}}
        <i class="fas fa-arrow-right ml-2"></i>
      </a>
    </div> -->
  </div>
</div>
<div class="bg-light py-5 my-5">
  <div class="container text-center ">
    <h2>{{'cms.customers.customers_say' | translate}}</h2>
    <p class="my-2">{{'cms.customers.working_with' | translate}}</p>
    <div class="row my-5">
      <swiper [pagination]="true" [autoplay]="{
            delay: 5000,
            disableOnInteraction: false
          }" [breakpoints]="{
      '640': {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: false
       },
      '768': {
        slidesPerView: 2,
        spaceBetween: 20,
        navigation: true
       },
      '1024': {
        slidesPerView: 3,
        spaceBetween: 30,
        navigation: true  
      }
    }">
        <ng-template swiperSlide *ngFor="let review of reviews; let i = index">
          <app-doctor-reviews [review]="review" [isEnglish]="isEnglish"> </app-doctor-reviews>
        </ng-template>
      </swiper>

    </div>
  </div>
</div>
 <div class="my-5 container text-center">
  <div class="row mb-5 justify-content-center">
    <h2 class="col-md-7  col-12">{{'cms.subscription.title' | translate}}</h2>
    <div class="col-md-8 col-12 mb-5">
      <div class="row mt-5">
        <p class="col-6 text-bold"><i class="fas fa-check text-primary fa-2x mr-2"></i>{{'cms.subscription.free_trial' |
          translate}}</p>
        <p class="col-6 text-bold"><i
            class="fas fa-check text-primary fa-2x mr-2"></i>{{'cms.subscription.cancel_anytime' | translate}}</p>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center  align-items-center my-5">
    <div class="btn-group btn-group-toggle" ngbRadioGroup name="billingSwitch" [(ngModel)]="param.recurringPeriod"
      (change)="loadSubscriptions()">
      <label ngbButtonLabel class="btn-simple btn-sm  btn-outline-primary relative">
        <input ngbButton type="radio" [value]="recurringPeriodEnum.annually">
        {{'cms.subscription.billed_yearly' | translate}}
        <span class="subscription-label discount-text"> 25% Off</span>
        <svg class="curved-line" viewBox="0 0 28 28" fill="none" width="28" height="28">
          <path d="M25.8535 25.9844C17.8535 24.8054 1.85352 18.3549 1.85351 1.98438" stroke="#1B448D" stroke-width="3"
            stroke-linecap="round" />
        </svg>
      </label>
      <label ngbButtonLabel class="btn-simple  btn-outline-primary btn-sm">
        <input ngbButton type="radio" [value]="recurringPeriodEnum.monthly">
        {{'cms.subscription.billed_monthly' | translate}}
      </label>
    </div>
  </div>

  <div class="row subscription-price">
    <div class="col-md-6 col-lg-4 col-12 mb-3" *ngFor="let subscription of pricingData; let i = index">
      <app-subscription-card *ngIf="pricingData" [isMid]="(i%2!=0)" [isEnglish]="isEnglish"
        [pricingData]="subscription">
      </app-subscription-card>
    </div>
  </div>
</div> 


<div class="bg-light-dark">
  <div class="container">
    <div class="row mb-5 pt-5">
      <div class="col-md-5 col-12">
        <h2>{{'cms.get_in_medoc.title' | translate}}</h2>
        <p class="mt-3">{{'cms.get_in_medoc.description' | translate}}</p>
      </div>
    </div>
    <div>
      <img src="assets/images/solution/chart.webp" alt="chart of Medoc analysis" width="300" height="100%">
    </div>
  </div>
</div>